import Handle from './src/Handle';
import Range from './src/Range';

// base rc-slider 9.7.2
import Slider from './src/Slider';

Slider.Range = Range;
Slider.Handle = Handle;
export {
  Handle as VcHandle,
  Range as VcRange,
  Slider as VcSlider,
};
